











import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class InsLangSwitch extends Vue {
  langText: string = '';

  changeLang (lang) {
    this.$Api.member.setUILanguage(lang).then((result) => {
      this.$i18n.locale = lang;
      localStorage.setItem('locale', lang);

      window.location.reload();
    }).catch((error) => {
      console.log(error);
    });
  }

  get currentlang () {
    return this.$Storage.get('locale');
  }

  mounted () {
    switch (this.currentlang) {
      case 'E':
        this.langText = '中';
        break;
      case 'C':
        this.langText = 'Eng';
        break;
    }
  }
}
